import {
    ERROR_MESSAGES
} from 'constants/validation-error-messages';
import * as yup from 'yup';

export const schema = yup.object({
    login: yup.string().required(ERROR_MESSAGES.REQUIRED),
    password: yup.string().required(ERROR_MESSAGES.REQUIRED)
});

export const schemaChange = yup.object({
    new_password: yup
        .string()
        .required(ERROR_MESSAGES.REQUIRED)
        .min(8, ERROR_MESSAGES.PASSWORD_LENGHT),
    new_password_repeat: yup
        .string()
        .oneOf([yup.ref('new_password'), null], ERROR_MESSAGES.PASSWORD_MATCH),
});
